export const selectStyles = {
  control: base => ({
    ...base,
    backgroundColor: 'hsla(0,0%,100%,.1)',
    border: 'none',
    '&:hover': {
      border: 'none',
      boxShadow: 'none',
    },
  }),
  dropdownIndicator: () => ({
    display: 'none',
  }),
  indicatorsContainer: () => ({
    display: 'none',
  }),
  input: base => ({
    ...base,
    color: '#fff',
  }),
  singleValue: base => ({
    ...base,
    color: '#fff',
    textAlign: 'center',
  }),
  valueContainer: base => ({
    ...base,
    minWidth: '94',
  }),
  menu: base => ({
    ...base,
    backgroundColor: '#3c3d3d',
    width: '186',
  }),
  option: (base, { isFocused }) => ({
    ...base,
    padding: '4px 12px',
    backgroundColor: isFocused && 'hsla(0,0%,100%,.05)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    span: {
      fontSize: '14',
      opacity: '0.5',
      marginLeft: '2',
    },
    '&:hover': {
      backgroundColor: 'hsla(0,0%,100%,.05)',
    },
    ':active': {
      backgroundColor: 'hsla(0,0%,100%,.05)',
    },
  }),
}
